<template>
  <div class="d-flex align-center justify-center">
    <div id="loginContainer">
      <LoginPage />
    </div>
  </div>
</template>

<script>
import LoginPage from "../components/Login/LoginPage";

export default {
  components: {
    LoginPage
  }
};
</script>

<style>
#loginContainer {
  height: 95vh;
  width: 100vw;
}
</style>